import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
export type ApplicantType = {
  id: string,
  name: string,
  type: string,
  translations: { en: string, es: string },
  financiallyResponsible: boolean,
  order: number,
  createdAt: Date,
  updatedAt: Date,
};

class ApplicantTypeService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/applicantTypes`, options);
  }
}

export default ApplicantTypeService;
